import React from "react";

const Loader = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-loader">
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Loader;
